import React, { useState } from 'react';
import { DEALS } from '../../constants/columns';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import { dealsOptions } from '../../constants/filterOptions';
import { useLocation, useNavigate } from 'react-router-dom';
import { setFilters } from '../../utils/setFilters';
import useTableUrlSync, { useInitialTableQuery } from '../../hooks/useTableUrlState';
import { saveFilterSnapshot, clearFilterSnapshot, readFilterValues } from '../../utils/filterSnapshot';
import { sortDealsParams } from '../../constants/sortParams';

// components
import Header from '../../components/Header/Header';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';
import ClientPopup from '../../components/ClientPopup/ClientPopup';
import HookForm from '../../components/HookForm/HookForm';

// icons
import icon from '../../brand/generated/sidebar/deals.svg';
import axios from '../../plugins/axios';
import { PERMISSION_CAN_EDIT_DEALS, ROLE_ADMIN } from '../../constants/roles';
import isUserHaveRole from '../../utils/isUserHaveRole';
import DealAutos from './DealAutos';
import Modal from '../../components/Modal/Modal';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import DealCarsModal from './DealCarsModal';
import bucket from '../../brand/generated/popover/delete.svg';
import RejectDealModal from './RejectDealModal';
import { socket } from '../../App';

export const FETCH_ALL_PAGESIZE = 20;
// const columns = DEALS;

const FILTER_NAMES = [...dealsOptions.map((option) => option.name), 'all'];

const Deals = ({ routerParams = {}, title = 'Ð¡Ð´ÐµÐ»ÐºÐ¸' }) => {
  const navigate = useNavigate();
  const location = useLocation();


  const [loading, setLoading] = useState(true);
  const tableStyle = { backgroundColor: 'white' };
  const [deals, setDeals] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const fromUrl = useInitialTableQuery(FILTER_NAMES);
  // ÐÐ´Ð¸Ð½ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½Ñ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°ÐµÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÑÑÐ°Ð½Ð¸Ñ (Ð½Ð¾Ð²ÑÐµ, ÐÐ£, Ð½ÐµÑÐ´Ð°ÑÐ½ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸),
  // Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐ½Ð¸Ð¼Ð¾Ðº ÑÐ¸Ð»ÑÑÑÐ¾Ð² Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ ÑÐ²Ð¾Ð¹.
  const snapshotKey = `deals${location.pathname}`;
  const [pagination, setPagination] = useState({
    page: fromUrl.page,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: fromUrl.pageSize || 10,
  });
  const [isFetchAll, setFetchAll] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [dealId, setDealId] = useState(null);
  const onCarClick = (id) => {
    setDealId(id);
    setModalOpen(true);
  };

  const [columns, setColumns] = useState(DEALS({ onCarClick }));

  const table = useTable(
    {
      columns,
      data: deals,
      initialState: {
        pageSize: pagination.pageSize,
      },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
      disableSortRemove: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { setGlobalFilter, page, setPageSize } = table;

  const [value, setValue] = useState(fromUrl.filters.all || '');
  const [queryParams, setQueryParams] = useState(fromUrl.filters);
  const filtersFormRef = React.useRef(null);
  useTableUrlSync({ queryParams, page: pagination.page, pageSize: pagination.pageSize });

  const applyFilters = (resetFilters) => {
    setFilters(resetFilters, setFetchAll, setPageSize, setPagination, setQueryParams, dealsOptions);

    if (resetFilters) {
      // Ð¤Ð¾ÑÐ¼Ð° Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÑÑÑ Ð¸Ð· defaultValue â Ð±ÐµÐ· Ð¾ÑÐ¸ÑÑÐºÐ¸ Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÐµ Ð¸Ð· Ð°Ð´ÑÐµÑÐ°
      // Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð²ÐµÑÐ½ÑÐ»Ð¸ÑÑ Ð±Ñ Ð¿ÑÐ¸ ÑÐ»ÐµÐ´ÑÑÑÐµÐ¼ Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð¿Ð°Ð½ÐµÐ»Ð¸.
      dealsOptions.forEach((option) => delete option.defaultValue);
      clearFilterSnapshot(snapshotKey);
    } else {
      saveFilterSnapshot(snapshotKey, dealsOptions);
    }
  };

  // Ð¤Ð¸Ð»ÑÑÑÑ Ð¸Ð· Ð°Ð´ÑÐµÑÐ°: Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ðº id Ð±ÐµÑÑÐ¼ Ð¸Ð· ÑÐ½Ð¸Ð¼ÐºÐ° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ.
  React.useEffect(() => {
    const restored = readFilterValues(snapshotKey, fromUrl.filters);
    dealsOptions.forEach((option) => {
      const value = restored[option.name];
      if (value === undefined) return;
      option.value = value;
      option.defaultValue = value;
      filtersFormRef.current?.setValue(option.name, value);
    });
    // Ð¢Ð¾Ð»ÑÐºÐ¾ Ð½Ð° Ð¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸: Ð´Ð°Ð»ÑÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸ÑÐ¼Ð¸ ÑÐ°ÑÐ¿Ð¾ÑÑÐ¶Ð°ÐµÑÑÑ ÑÐ¾ÑÐ¼Ð°.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addDeal = () => {
    navigate('/deals/create');
  };

  const handleNavigate = (index) => {
    navigate(`/deals/deal/${deals.find((item) => item.id === index).id}/main-info`, {
      state: deals.find((item) => item.id === index),
    });
  };

  const getDeals = (params) => {
    setLoading(true);
    axios
      .get('/api/crm/deals/getDeals', { params: { ...params, ...routerParams, _ts: Date.now() } })
      .then((res) => {
        setDeals(res.data.deals);
        setPagination({
          ...res.data.pagination,
          page: res.data.pagination?.pageNumber,
          pageSize: pagination.pageSize,
        });
        setDataCount(
          res.data.pagination?.count ??
            res.data.pagination?.totalCount ??
            res.data.pagination?.totalItems ??
            res.data.count ??
            0
        );
      })
      .catch((error) => {})
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    const onNavUpdate = () => {
      getDeals({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    };

    socket.on('listenCrmNavigationNotifications', onNavUpdate);
    return () => {
      socket.off('listenCrmNavigationNotifications', onNavUpdate);
    };
  }, [pagination.page, pagination.pageSize, queryParams, routerParams]);

  React.useEffect(() => {
    if (!isFetchAll) {
      getDeals({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    }
  }, [pagination.page, pagination.pageSize, queryParams]);
  React.useEffect(() => {
    getDeals({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
  }, [location]);

  

  const [showClientPopup, setShowClientPopup] = React.useState(false);
  const [clientId, setClientId] = React.useState(null);

  const sortBy = (value) => {
    if (!sortDealsParams.get(value)) return;
    if (sortDealsParams.get(value) === queryParams.sortBy) {
      queryParams.sortBy = '';
    } else {
      queryParams.sortBy = sortDealsParams.get(value);
    }
    setFetchAll(false);
    setQueryParams({ ...queryParams });
  };

  // Ð£Ð´Ð°Ð»ÐµÐ½Ð¸Ðµ ÑÐ´ÐµÐ»ÐºÐ¸ â ÑÐ¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ.
  // Ð Ð°Ð½ÑÑÐµ Ð¿ÑÐ½ÐºÑ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»ÑÑ Ð²ÑÐµÐ¼, Ñ ÐºÐ¾Ð³Ð¾ Ð² ÑÐ¾Ð»Ð¸ Ð²ÐºÐ»ÑÑÐµÐ½Ð¾ Â«ÐÐ¾Ð¶ÐµÑ ÑÐ´Ð°Ð»ÑÑÑ
  // ÑÐ´ÐµÐ»ÐºÐ¸Â», Ð¸ ÑÐ´Ð°Ð»ÑÐ» ÑÑÐ°Ð·Ñ Ð¿Ð¾ ÐºÐ»Ð¸ÐºÑ, Ð±ÐµÐ· Ð²Ð¾Ð¿ÑÐ¾ÑÐ°.
  const [deleteDeal, setDeleteDeal] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const onConfirmDelete = async () => {
    setDeleting(true);
    try {
      await axios.post('/api/crm/deals/removeDeal', { id: deleteDeal?.id });
      setDeleteDeal(null);
      getDeals({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
    } finally {
      setDeleting(false);
    }
  };
  const popover = isUserHaveRole(ROLE_ADMIN)
    ? [
        {
          title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ ÑÐ´ÐµÐ»ÐºÑ',
          icon: bucket,
          onClick: (row) => setDeleteDeal(row),
        },
      ]
    : undefined;

  const onFastSearch = (value) => {
    setQueryParams({
      ...queryParams,
      all: value,
    })
  }

  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [rejectDealId, setRejectDealId] = useState(null);
  const onDropItemToTrash = (deal) => {
    console.log(deal);
    setRejectDealId(deal?.id)
    setOpenRejectModal(true);
  }
  const onDealRejected = () => {
    getDeals({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams });
  }



  return (
    <>
      {showClientPopup && <ClientPopup isOpen={showClientPopup} setOpen={setShowClientPopup} clientId={clientId} />}
      <Header title={title} icon={icon} />
      <br />
      <br />
      <br />
      <br />
      <TableTabs
        setFilter={onFastSearch}
        value={value}
        filterComponent={
          <HookForm
            ref={filtersFormRef}
            inputs={dealsOptions}
            grid={{
              display: 'grid',
              gap: '10px',
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
            }}
            style={{ backgroundColor: 'transparent' }}
          />
        }
        handleSearchParams={applyFilters}
        defaultFiltersOpen={Object.keys(fromUrl.filters).some((name) => name !== 'all')}
        setValue={setValue}
        navigate={addDeal}
        button={'ÐÑÐ¾Ð´Ð°ÑÑ Ð°Ð²ÑÐ¾'}
        buttons={[
          {
            text: 'ÐÑÐ¾Ð´Ð°ÑÑ Ð´Ð¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
            onClick: () => navigate('/deals/equipment'),
          },
        ]}
        // permission={PERMISSION_CAN_EDIT_DEALS}
        inputPlaceholder={'ÐÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐ°Ð¼'}
      />
      <br />
      {!page.length && !loading ? (
        <Empty />
      ) : (
        <>
          <Table
            table={table}
            all={'ÑÐ´ÐµÐ»Ð¾Ðº'}
            style={tableStyle}
            handleNavigate={handleNavigate}
            pagination
            sort
            setPagination={setPagination}
            setFetchAll={setFetchAll}
            isFetchAll={isFetchAll}
            setData={setDeals}
            p={pagination}
            setClientId={setClientId}
            setOpenClientPopup={setShowClientPopup}
            loading={loading}
            setLoading={setLoading}
            columns={columns}
            setColumns={setColumns}
            columnsSettingsKey="deals"
            queryParams={queryParams}
            api={'/api/crm/deals/getDeals'}
            response={'deals'}
            isSortable
            dataCount={dataCount}
            minWidth={1400}
            handleSortTable={sortBy}
            popover={popover}
            onDropItemToTrash={onDropItemToTrash}
          />
          <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setModalOpen(false)}
            contentStyle={{
              height: 'max-content',
            }}
          >
            <DealCarsModal dealId={dealId} />
          </Modal>
        </>
      )}

      <RejectDealModal isOpen={openRejectModal} onClose={setOpenRejectModal} dealId={rejectDealId} onSuccess={onDealRejected}/>
      <ConfirmModal
        isOpen={!!deleteDeal}
        onClose={() => setDeleteDeal(null)}
        title="Ð£Ð´Ð°Ð»ÐµÐ½Ð¸Ðµ ÑÐ´ÐµÐ»ÐºÐ¸"
        text={`ÐÑ ÑÐ²ÐµÑÐµÐ½Ñ, ÑÑÐ¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÐ´ÐµÐ»ÐºÑ â${deleteDeal?.id ?? ''}? ÐÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÑÐ¾ Ð±ÑÐ´ÐµÑ Ð½ÐµÐ»ÑÐ·Ñ.`}
        confirmText="ÐÐ°"
        cancelText="ÐÐµÑ"
        loading={deleting}
        onConfirm={onConfirmDelete}
      />
    </>
  );
};

export default Deals;
